import { render } from "./post-smtp-days-selector.vue?vue&type=template&id=0ba96be9&scoped=true"
import script from "./post-smtp-days-selector.vue?vue&type=script&lang=js"
export * from "./post-smtp-days-selector.vue?vue&type=script&lang=js"

import "./post-smtp-days-selector.vue?vue&type=style&index=0&id=0ba96be9&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ba96be9"]])

export default __exports__